try{
	function get_datatable_data(obj){
		// am.$('body').attr('data-is_mobile_or_tablet', is_mobile_or_tablet() )
		try{
			if(obj.ajax_dt){
				obj.func();
				hide_loading_svg();
			}else{
				return new Promise((resolve, reject) => {
					am.$.get(obj.url, obj.params, function (data) {
						// if(obj.card_view){
						// 	is_mobile_or_tablet() ? obj.cb_mobile(data) : obj.cb_desktop(data)
						// }else{
							obj.func(data);
						// }
						hide_loading_svg();
						resolve();
					});
				});
			}
		}catch(e){
			console.log(e);
		}
	}
}catch(e){
	console.log(e);
}


am.$(document).ready(function() {
	am.$(window).resize(function() {
		let key = false;
		let breakpointSize = 'desktop';
		const $body = am.$('body');
		const $table = am.$('[data-resize_key]');
		
		if($body.hasClass('am-breakpoint-small') || $body.hasClass('am-breakpoint-medium'))
			breakpointSize = 'mobile';

		if($table.length > 0 && $body.length > 0 && $body.attr('data-last_set_breakpoint') != breakpointSize ){
			show_loading_svg();
			$body.attr('data-last_set_breakpoint', breakpointSize);
			key = $table.attr('data-resize_key');
			$table.parent('.dataTables_wrapper').remove();

			if(key)
				get_datatable_data(get_resize_object(key));
		}
	});
});